import React, { useState, useEffect, useRef, useReducer } from 'react'
import { firestore } from '../../../../../components/firebase/FirebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';

import { Accordion, Spinner } from 'react-bootstrap'
import { useWizard } from '../wizardContext';
import clsx from 'clsx';
import { holesDef, scoringDef } from '../module/holeDef';
import { stepOneReducer } from '../module/reducer';
import { handleModeChange, handleHoleChange, handleHandicapChange, handleScoringChange, handleRoundNameChange } from '../module/stepOneUtils';
import { useTranslation } from 'react-i18next';
import { convertScoring, holeConvert, textConvert } from '../../../../../components/language/dropdown/textconvert';

const EditStepOneByPlayer = () => {
    const { t, i18n } = useTranslation();
    const { stepData, updateStepData } = useWizard();
    const data1 = stepData.stepOne;
    const [courseHole, setCourseHole] = useState([]);
    const gameModeRef = useRef([
        {
            name: 'Stroke Play',
            value: 'str',
        },
        {
            name: 'Stableford',
            value: 'stb'
        },
        {
            name: 'Match Play',
            value: 'mp'
        }
    ])

    const initialState = {
        course: data1.course,
        roundName: data1.roundName,
        holes: data1.holes,
        holesCourse: data1.holesCourse,
        gameMode: data1.gameMode,
        handicap: data1.handicap,
        scoring: data1.scoring,
        scoringType: data1.scoringType,
    };

    const [state, dispatch] = useReducer(stepOneReducer, initialState);

    // console.log(state);

    useEffect(() => {
        async function getCourseData(courseId) {
            try {
                const courseCollection = collection(firestore, 'courses');
                const q = query(courseCollection, where('id', '==', courseId));
                const courseSnapshot = await getDocs(q);
                if (!courseSnapshot.empty) {
                    const data = courseSnapshot.docs[0].data();
                    // update state after get course data
                    dispatch({ type: 'COURSE', payload: data, updateStepData: updateStepData, });
                    dispatch({ type: 'RENAME', payload: data1.roundName, updateStepData: updateStepData, });
                    dispatch({ type: 'HOLES', payload: data1.holes, updateStepData: updateStepData, });
                    dispatch({ type: 'HOLESCOURSE', payload: data1.holesCourse, updateStepData: updateStepData, });
                    dispatch({ type: 'MODE', payload: data1.gameMode, updateStepData: updateStepData, });

                    const scoringList = scoringDef(state.gameMode, data1.handicap);

                    dispatch({
                        type: 'HANDICAP',
                        payload: {
                            handicap: data1.handicap,
                            scoringType: scoringList
                        },
                        updateStepData: updateStepData,
                    });

                    dispatch({ type: 'SCORRING', payload: data1.scoring, updateStepData: updateStepData, });

                } else {
                    console.log('Not found course ', courseId);
                }
            } catch (error) {
                console.error('Fail to get course Data for ', courseId, error);
            }
        }
        if (!state.course && typeof data1.course !== "object") {

            getCourseData(data1.course)
        }

    }, [data1.course, state.course]);

    useEffect(() => {
        async function getHoles(courseId = state.course.id) {
            const numberOfHoleList = [];
            try {
                const holesCollection = collection(firestore, "courseHoles");
                const q = query(holesCollection, where('courseId', '==', courseId));
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {
                    querySnapshot.forEach(doc => {
                        const data = doc.data();
                        const existingHole = numberOfHoleList.find(hole => hole.numberOfHole === data.numberOfHole);

                        if (existingHole) {
                            if (!existingHole.courseHoleNames.includes(data.courseHoleName)) {
                                existingHole.courseHoleNames.push(data.courseHoleName);
                            }
                            // Add doc.id if not already in the list
                            if (!existingHole.id.includes(doc.id)) {
                                existingHole.id.push(doc.id);
                            }
                        } else {
                            numberOfHoleList.push({
                                numberOfHole: data.numberOfHole,
                                courseHoleNames: [data.courseHoleName],
                                id: [doc.id]
                            });
                        }
                    });
                }
                setCourseHole(numberOfHoleList);
            } catch (error) {
                console.error('fail to load course', error);
            }
        }
        if (state.course) {
            getHoles()
        }
    }, [state.course])



    return (
        <>
            <Accordion flush>
                <button className='btn p-3 w-100 text-center rounded-3 theme-dark-bg border shadow-sm'
                    style={{ backgroundColor: '#F5F5F5' }}>
                    {state.course ?
                        <div className='d-flex justify-content-center align-items-center'>
                            <img src={state?.course?.profileImage} alt="img" width={60} height={60} className='me-2 rounded-circle' />
                            <div>
                                <h4 className='fw-600'>
                                    {i18n.language === 'th' ?
                                        `${state.course?.courseNameThai}`
                                        :
                                        `${state.course?.courseName}`
                                    }
                                </h4>
                                <small>
                                    {state?.course?.location?.subDistrictEng}, {state?.course?.location?.provinceEng}
                                </small>
                            </div>
                        </div>
                        :
                        <Spinner variant="dark" animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                </button>
                <Accordion.Item className='border-0'>
                    <h5 className='mt-4 mb-1'><strong>{t(textConvert('Round Name'))}</strong></h5>
                    <input type="text" name="round-name" id="round-name"
                        className='form-control'
                        value={state.roundName}
                        onChange={(e) => handleRoundNameChange(e, updateStepData, dispatch)}
                    />

                    <h5 className='mt-4 mb-1'><strong>{t(textConvert('Playing Holes'))}</strong></h5>
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        {courseHole.map((hole, idx) =>
                            <div key={idx} className={clsx('col-sm-3 step-three-radio-card pointer p-3 p-sm-4', { 'active': state.holes === hole.numberOfHole })}
                                onClick={() => handleHoleChange(hole, updateStepData, dispatch)}
                            >
                                <h6 className='fw-600'>{t(holeConvert(hole.numberOfHole))}</h6>
                                <i className="bi bi-check-circle-fill text-current step-one-checked-icon"></i>
                            </div>
                        )}
                    </div>
                    {/* <div className={clsx('mb-2', { 'd-none': !courseHole.length })}>
                        <select name="holeCourseSelect" id="holeCourseSelect" className='form-select'
                            value={state.holesCourse}
                            onChange={(e) => dispatch({ type: 'HOLESCOURSE', payload: e.target.value, updateStepData: updateStepData, })}
                        >
                            <option value=''>No Select</option>
                            {courseHole.find((item) => item.numberOfHole === state.holes)?.courseHoleNames?.map((courseHoleName, index) => {
                                const holeId = courseHole.find(item => item.numberOfHole === state.holes)?.id[index];
                                return (
                                    <option key={holeId} value={holeId}>
                                        {courseHoleName}
                                    </option>
                                );
                            })}
                        </select>
                    </div> */}

                    {/* <h5 className='mt-4 mb-1'><strong>Game Mode</strong></h5>
                    <div className='d-flex align-items-center gap-2 mb-2 flex-wrap' >
                        {gameModeRef.current.map((mode, idx) =>
                            <div key={idx} className={clsx('col-sm-3 step-three-radio-card pointer p-3 p-sm-4', { 'active': state.gameMode === mode.value })}
                                onClick={() => handleModeChange(mode, updateStepData, dispatch, scoringDef)}
                            >
                                <h6 className='fw-600'>{mode.name}</h6>
                                <i className="bi bi-check-circle-fill text-current step-one-checked-icon"></i>
                            </div>
                        )}
                    </div> */}

                    <div className='d-sm-flex align-items-center gap-2 mb-2'>
                        <label htmlFor="game-mode" className='col-4'><h5 className='fw-600'>{t(textConvert('Game Mode'))}</h5></label>
                        <select name="game-mode" id="game-mode" className='form-select form-select-sm'
                            onChange={(e) => handleModeChange(e.target.value, updateStepData, dispatch, scoringDef)}
                            value={state.gameMode}
                        >
                            {gameModeRef.current.map((mode, idx) =>
                                <option key={idx} value={mode.value}>{t(textConvert(mode.name))}</option>
                            )}
                        </select>
                    </div>

                    <div className='d-sm-flex align-items-center gap-2 mb-2'>
                        <label htmlFor="handicap" className='col-4'><h5 className='fw-600'>{t(textConvert('Handicap'))}</h5></label>
                        <select name="handicap" id="handicap" className='form-select form-select-sm' value={state.handicap} onChange={(e) => handleHandicapChange(e, updateStepData, state, dispatch)}>
                            <option value="scratch">{t(textConvert('scratch_no_handicap_applied'))}</option>
                            <option value="whs">{t(textConvert('whs_world_handicap_system'))}</option>
                            <option value="s36">{t(textConvert('s_thirtysix_system_thirtysix'))}</option>
                        </select>
                    </div>

                    <div className='d-sm-flex align-items-center gap-2 mb-2'>
                        <label htmlFor="scoring" className='col-4'><h5 className='fw-600'>{t(textConvert('Scoring'))}</h5></label>
                        <select name="scoring" id="scoring" className='form-select form-select-sm' value={state.scoring} onChange={(e) => handleScoringChange(e, updateStepData, dispatch)}>
                            {state.scoringType.map((type, index) => (
                                <option key={index} value={type}>{t(textConvert(convertScoring(type)))}</option>
                            ))}
                        </select>
                    </div>

                </Accordion.Item>
            </Accordion>
        </>
    )
}

export default EditStepOneByPlayer